import React, { useCallback, useRef, useEffect } from "react"
import { Box, List, ListItemButton, Typography, useTheme } from "@mui/material"
import clsx from "clsx"
import { deepmerge } from "@mui/utils"
import { useTranslation } from "providers/i18n"

export const OrdinalSelector = (props) => {
  const {
    levels = [],
    onClickOrdinal = () => {},
    selectedOrdinal,
    label = "Select Floor",
    sx = {},
    locationOrdinal,
    className = "",
    currentVenue,
    ...restProps
  } = props

  const { t } = useTranslation()
  const theme = useTheme()
  const { root, listItemButton, ordinalSelectorTitle, ordinalList } =
    theme.components[`AppOrdinalSelector`]?.styleOverrides || {}

  const listItemRef = useRef(null)

  const scrollToRef = useCallback(() => {
    if (listItemRef.current) {
      listItemRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      })
    }
  }, [listItemRef])

  const handleClick = useCallback(
    (ordinal) => () => {
      onClickOrdinal(ordinal)
    },
    [onClickOrdinal]
  )

  useEffect(() => {
    if (levels && levels.length > 0) scrollToRef()
  }, [selectedOrdinal, scrollToRef, levels])

  if (levels.length === 0) return null
  return (
    <Box
      className={clsx("OrdinalSelector-root", className)}
      sx={deepmerge(root, sx)}
    >
      <Typography className="OrdinalSelector-label" sx={ordinalSelectorTitle}>
        {t(label)}
      </Typography>
      <List sx={ordinalList} {...restProps} className="OrdinalSelector-list">
        {levels.map((level) => {
          const isCurrentLocation =
            currentVenue === level?.properties?.venue_id &&
            locationOrdinal === level?.properties?.ordinal
          return (
            <ListItemButton
              className={`OrdinalSelector-button ${
                isCurrentLocation ? "is-location-ordinal" : ""
              }`}
              sx={listItemButton}
              selected={level?.properties?.ordinal === selectedOrdinal}
              key={`ordinal-selector-${level?.id}`}
              onClick={handleClick(level?.properties?.ordinal)}
              ref={
                level?.properties?.ordinal === selectedOrdinal
                  ? listItemRef
                  : null
              }
            >
              {level?.properties?.name?.en}
            </ListItemButton>
          )
        })}
      </List>
    </Box>
  )
}
